import actionsPanelActions from '../actions/actionsPanel.actions';

const actionsPanelReducer = (state, action) => {
  switch (action.type) {
    case actionsPanelActions.UPDATE_ACTIONS_PANEL_REQUEST:
      return Object.assign({}, state, {
        policies: action.policies,
        proposals: action.proposals,
      });
    default:
      return state;
  }
};

export default actionsPanelReducer;
